import React from 'react';
import ReactDOM from 'react-dom/client';
import { Sentry } from './lib/sentry';
import './lib/posthog';
import { App } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p className="p-8 text-center text-red-500">Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
